import React from "react";
import { Modal } from "react-bootstrap";
import Pesame from "./oraciones/Pesame";
import AveMaria from "./oraciones/AveMaria";
import BajoTuAmparo from "./oraciones/BajoTuAmparo";
import ConsagracionJesus from "./oraciones/ConsagracionJesus";
import ConsagracionVirgen from "./oraciones/ConsagracionVirgen";
import Gloria from "./oraciones/Gloria";
import PadreNuestro from "./oraciones/PadreNuestro";
import PorLaPatria from "./oraciones/PorLaPatria";
import Salve from "./oraciones/Salve";
import SanMiguel from "./oraciones/SanMiguel";
import Angelus from "./oraciones/Angelus";
import Jaculatorias from "./oraciones/Jaculatorias";
import JaculatoriasSanJose from "./oraciones/JaculatoriasSanJose";
import Mensaje131095 from "./mensajesModal/13-10-95";
import Mensaje271195 from "./mensajesModal/27-11-95";
import Mensaje210396 from "./mensajesModal/21-03-96";
import Mensaje190698 from "./mensajesModal/19-06-98";
import Mensaje131098 from "./mensajesModal/13-10-98";
import Mensaje131001 from "./mensajesModal/13-10-01";
import Mensaje151001 from "./mensajesModal/15-10-01";

export default function Oracion({ oracionElegida }) {

  return (
    <>
      <Modal.Body>
        <div className="text-center mt-3">
          {oracionElegida === "aveMaria" && <AveMaria />}
          {oracionElegida === "bajoTuAmparo" && <BajoTuAmparo />}
          {oracionElegida === "consagracionJesus" && <ConsagracionJesus />}
          {oracionElegida === "consagracionVirgen" && <ConsagracionVirgen />}
          {oracionElegida === "gloria" && <Gloria />}
          {oracionElegida === "padreNuestro" && <PadreNuestro />}
          {oracionElegida === "pesame" && <Pesame />}
          {oracionElegida === "porLaPatria" && <PorLaPatria />}
          {oracionElegida === "salve" && <Salve />}
          {oracionElegida === "sanMiguel" && <SanMiguel />}
          {oracionElegida === "angelus" && <Angelus />}
          {oracionElegida === "jaculatorias" && <Jaculatorias />}
          {oracionElegida === "jaculatoriasSanJose" && <JaculatoriasSanJose />}
          {oracionElegida === "mensaje13-10-95" && <Mensaje131095 />}
          {oracionElegida === "mensaje27-11-95" && <Mensaje271195 />}
          {oracionElegida === "mensaje21-03-96" && <Mensaje210396 />}
          {oracionElegida === "mensaje19-06-98" && <Mensaje190698 />}
          {oracionElegida === "mensaje13-10-98" && <Mensaje131098 />}
          {oracionElegida === "mensaje13-10-01" && <Mensaje131001 />}
          {oracionElegida === "mensaje15-10-01" && <Mensaje151001 />}
        </div>
        {/* <p>{oracion}</p> */}
      </Modal.Body>
    </>
  );
}
